import i18n from "i18n";
// District-level menu items shown when inside a specific district
export const menuDistrict = [
  // District "Home" (overview page for district)
  { id: 1, get text() { return i18n.t("layout:home"); }, icon: "homeIcon", to: "home", check: "home" },

  // Schools section with submenus → Campuses & Buildings
  {
    id: 2,
    get text() { return i18n.t("layout:schools"); },
    icon: "campusIcon",
    child: [
      { get text() { return i18n.t("common:campuses"); }, to: "campus", check: "campus" },     // Submenu: Campuses
      { get text() { return i18n.t("common:buildings"); }, to: "buildings", check: "buildings" } // Submenu: Buildings
    ],
    to: "school",
    check: "school",
  },

  // Users section with submenus → Staff, Students, Law Enforcement
  {
    id: 3,
    get text() { return i18n.t("common:users"); },
    icon: "userIcon",
    child: [
      { get text() { return i18n.t("common:staff"); }, icon: "staffIcon", to: "staff", check: "staff" }, // Submenu: Staff
      // {
      //   text: "Students",
      //   icon: "studentIcon",
      //   to: "students",
      //   check: "students",
      // },
      {
        get text() { return i18n.t("common:lawEnforcement"); },
        icon: "staffIcon",
        to: "lawEnforcement",
        check: "lawEnforcement",
      },
    ],
    to: "users",
    check: "users",
  },
  {
    id: 4,
    get text() { return i18n.t("layout:domains"); },
    icon: "domainIcon",
    child: [
      { get text() { return i18n.t("layout:domains"); }, to: "list", check: "list" }, // Submenu: Domain
      {
        get text() { return i18n.t("common:n911Dispatcher"); },
        to: "911Dispatcher",
        check: "911Dispatcher",
      },
    ],
    to: "domains",
    check: "domains",
  },

  // Settings section → district-level configuration
  {
    id: 5,
    get text() { return i18n.t("layout:incidents"); },
    icon: "incidentIcon",
    to: "incidents",
    check: "incidents",
  },
  // Settings section → district-level configuration
  {
    id: 6,
    get text() { return i18n.t("layout:settings"); },
    icon: "settingIcon",
    to: "settings/admins",
    check: "settings",
  },
];
